export type ProcessingTenancy = 'Stateful' | 'Stateless';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isProcessingTenancy = (data: any): data is ProcessingTenancy =>
  data === 'Stateful' || data === 'Stateless';
